import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const ReportsTable = ({ rows, columns, getRowId }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 20, 50, 100]}
        getRowId={getRowId}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 100, page: 0 },
          },
        }}
        sx={{
          '& .MuiTablePagination-selectLabel': {
            margin: '0px',
            color: '#0000008e',
          },
          '& .MuiTablePagination-displayedRows': {
            margin: '0px',
          },
          '& .MuiTablePagination-actions': {
            color: '#0000008e',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: '#565453',
          },
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
        }}
      />
    </Box>
  );
};

export default ReportsTable;
